import { Link } from 'react-router-dom';

export default function LandingHero() {
  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20digital%20marketing%20technology%20background%20with%20glowing%20geometric%20shapes%20and%20data%20streams%2C%20dark%20navy%20and%20charcoal%20tones%20with%20subtle%20orange%20and%20amber%20light%20accents%2C%20modern%20minimalist%20tech%20aesthetic%2C%20high%20contrast%2C%20no%20text%2C%20ultra%20wide%20format%2C%20cinematic%20lighting%2C%20deep%20shadows&width=1920&height=1080&seq=landing-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-8 text-center pt-24 pb-16">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 text-orange-300 text-xs font-semibold px-4 py-2 rounded-full mb-8 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-orange-400 animate-pulse" />
          The #1 AI Ad Generator for Small Businesses
        </div>

        {/* H1 */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-6">
          Create High-Converting Ads{' '}
          <span className="text-orange-400">in Seconds</span>{' '}
          with AI
        </h1>

        {/* Subheadline */}
        <p className="text-lg sm:text-xl text-stone-300 max-w-2xl mx-auto mb-4 leading-relaxed">
          No marketing experience needed. Our <strong className="text-white">AI ad generator</strong> writes
          professional ad copy and creates stunning visuals for Facebook, Instagram, and Google — in under a minute.
        </p>
        <p className="text-base text-stone-400 max-w-xl mx-auto mb-10">
          Perfect for contractors, local businesses, and entrepreneurs who want to grow without hiring an agency.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-orange-500/30 hover:-translate-y-0.5"
          >
            Generate Your First Ad — It&apos;s Free
          </Link>
          <a
            href="#how-it-works"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            See How It Works
          </a>
        </div>

        {/* Social proof strip */}
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
          {[
            { value: '10,000+', label: 'Ads Generated' },
            { value: '4.9★', label: 'Average Rating' },
            { value: '3 mins', label: 'Avg. Creation Time' },
            { value: 'Free', label: 'To Start' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl font-black text-white">{stat.value}</div>
              <div className="text-xs text-stone-400 font-medium mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </header>
  );
}
